<template>
  <USlideover v-model="uiStore.cartSlide">
    <div class="h-full flex flex-col">
      <!-- Fixed Header -->
      <div class="px-4 py-3 border-b">
        <div class="flex items-center justify-between">
          <h3 class="text-base font-semibold leading-6 text-gray-900">
            Sepet
            <span v-if="cartStore.totalItems > 0" class="text-orange-500 text-sm">
              ({{ cartStore.totalItems }} ürün)
            </span>
          </h3>
          <UButton color="gray" variant="ghost" icon="i-heroicons-x-mark-20-solid" class="-my-1" @click="closeSlide" />
        </div>
      </div>

      <!-- Scrollable Content -->
      <div class="flex-1 overflow-y-auto">
        <div v-if="cartStore.cartItems?.length > 0" class="divide-y divide-slate-200">
          <!-- Vendor gruplarına göre ürünleri listele -->
          <div v-for="(group, vendorId) in cartStore.groupedByVendor" :key="vendorId" class="bg-white">
            <!-- Satıcı başlığı -->
            <div class="sticky top-0 z-10 bg-sky-100  px-4 py-3 border-b border-slate-200">
              <div class="flex items-center justify-between">
                <div class="flex items-center space-x-2 ">
                  <UIcon name="i-heroicons-building-storefront" class="w-4 h-4 text-slate-400" />
                  <h4 class="text-sm font-medium text-slate-700">
                    {{ group.vendor_name }}
                  </h4>
                </div>
                <UButton :to="`/magaza/${group.vendor_slug}-m-${group.vendor_id}`" color="gray" variant="ghost"
                  size="xs" class="flex items-center space-x-1" @click="closeSlide">
                  <span>Mağazaya Git</span>
                  <UIcon name="i-heroicons-arrow-right" class="w-3.5 h-3.5" />
                </UButton>
              </div>
            </div>

            <!-- Satıcının ürünleri -->
            <div class="px-4">
              <div v-for="cartItem in group.items" :key="cartItem.id" class="relative  transition-all duration-700"
                :class="{
                  'bg-gradient-to-r from-orange-100/80 via-orange-50/50 to-transparent':
                    cartStore.lastAddedItemId === cartItem.id
                }">
                <FrontendCartListItem :item="cartItem" />
                <div v-if="cartStore.lastAddedItemId === cartItem.id"
                  class="absolute right-0 top-3 flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-orange-700 bg-orange-100 rounded-full">
                  <UIcon name="i-heroicons-check-circle" class="w-4 h-4" />
                  <span>Sepete Eklendi</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="flex flex-col items-center justify-center h-full text-center py-12 px-4">
          <UIcon name="i-heroicons-shopping-bag" class="w-16 h-16 text-slate-300 mb-4" />
          <p class="text-slate-500">Sepetinizde ürün bulunmuyor</p>
          <UButton color="orange" variant="ghost" class="mt-4" @click="closeSlide">
            Alışverişe Devam Et
          </UButton>
        </div>
      </div>

      <!-- Fixed Footer -->
      <div v-if="cartStore.cartItems?.length > 0" class="border-t bg-white">
        <div class="p-4 space-y-4">
          <div class="flex justify-between items-center">
            <span class="text-base font-medium">Toplam</span>
            <span class="text-lg font-semibold text-orange-500">
              {{ formatPrice(cartStore.cartTotal) }}
            </span>
          </div>
          <div class="grid grid-cols-2 gap-3">
            <UButton color="sky" variant="soft" to="/sepet" block @click="closeSlide">
              Sepete Git
            </UButton>
            <UButton color="orange" to="/auth?callback=/odeme" block @click="closeSlide">
              Ödeme Yap
            </UButton>
          </div>
        </div>
      </div>
    </div>
  </USlideover>
</template>

<script setup>
const cartStore = useCartStore()
const uiStore = useUiStore()

const closeSlide = () => {
  uiStore.cartSlide = false
}

// Sepet verilerini yükle
onMounted(async () => {
  if (cartStore.cartItems?.length === 0) {
    await cartStore.fetchCartItems()
  }
})
</script>

<style scoped>
.overflow-y-auto {
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: transparent;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 3px;
}
</style>
